import moment from "moment";
import "moment-timezone";

const guessedTimezone = moment.tz.guess();

/**
 * Returns the user's configured timezone.
 *
 * Reads the `timezone` value from localStorage (set from the user's options),
 * falling back to the browser-guessed timezone when it is not set. This is the
 * single source of truth for the timezone used when computing local-time day
 * boundaries for the date pickers and the default date range.
 *
 * @returns {string} An IANA timezone name (e.g. "Pacific/Auckland").
 */
export function getUserTimezone() {
  try {
    if (typeof localStorage !== "undefined") {
      return localStorage.getItem("timezone") || guessedTimezone;
    }
  } catch {
    // localStorage unavailable or blocked; fall back to guessed timezone.
  }

  return guessedTimezone;
}
